import { DonationBox, NewsletterBox, FooterNav } from '@common'
import { Grid, Box } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
import { IFonts } from '@interfaces'

interface IFooter {
  activeFontFamily?: IFonts
}

const Footer = ({ activeFontFamily }: IFooter) => {
  const { t } = useTranslation('common')
  const footerFontFamily = "'Duru Sans','Duru Sans Regular',sans-serif"
  const footerActiveFontFamily: IFonts = 'duruSans'

  return (
    <Grid
      templateColumns={{ base: '1fr', lg: '400px 1fr', xl: '470px 1fr' }}
      gap={0}
      position="relative"
      as="footer"
      fontFamily={footerFontFamily}
      sx={{
        '&, & *': {
          fontFamily: `${footerFontFamily} !important`,
        },
      }}
    >
      <DonationBox activeFontFamily={footerActiveFontFamily} />
      <Box display="grid" gridTemplateRows="auto 1fr">
        <NewsletterBox
          title={t('newsletter.title')}
          description1={t('newsletter.description1')}
          description2={t('newsletter.description2')}
          buttonLabel={t('common:newsRegisterButtonLabel')}
          activeFontFamily={footerActiveFontFamily}
        />
        <FooterNav activeFontFamily={footerActiveFontFamily} />
      </Box>
    </Grid>
  )
}

export default Footer